import React from 'react';
import { FadeIn } from './FadeIn';
import { CTAButton } from './CTAButton';
export function UniqueMechanism() {
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-[#141414] relative overflow-hidden" data-id="element-208">
      {/* Subtle background accent */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-brand-amber/5 blur-[120px] rounded-full pointer-events-none" data-id="element-209"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-210">
        <FadeIn data-id="element-211">
          <h2 className="text-3xl sm:text-4xl font-serif text-brand-offwhite mb-12 text-center" data-id="element-212">
            El Protocolo de Claridad en el Caos
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-213">
          <div className="flex flex-col md:flex-row items-center gap-10 md:gap-14 mb-12" data-id="element-214">
            <div className="flex-1 text-center md:text-left" data-id="element-215">
              <p className="text-lg text-brand-offwhite/80 leading-relaxed" data-id="element-216">
                A diferencia de la terapia de pareja tradicional que toma meses,
                este sistema de 7 pasos está diseñado para ser un{' '}
                <span className="text-brand-amber font-medium" data-id="element-217">
                  «primer auxilio emocional»
                </span>
                . No te dice qué hacer; te devuelve la capacidad visual para
                decidir por ti mismo. Es un filtro de neutralidad radical que
                separa el trauma de la realidad para que tu decisión —quedarte o
                irte— sea definitiva y sin arrepentimientos.
              </p>
            </div>
            <div className="flex-shrink-0 w-64 sm:w-72 md:w-80" data-id="element-218">
              <img src="https://cdn.magicpatterns.com/uploads/mvaKnCGjsz3acVQd6yp4yx/IMG_8534.png" alt="Superé la traición, ahora escalo mi futuro" className="w-full rounded-2xl shadow-2xl border border-white/5" data-id="element-219" />
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-220">
          <div className="text-center" data-id="element-221">
            <CTAButton scrollToId="offer-block" data-id="element-222" />
          </div>
        </FadeIn>
      </div>
    </section>;
}